import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  OPEN_PANEL_MAIN_CONTENT_LEFT_CONVERTER_TOKEN, OpenPanelMainContentLeftConverter
} from './open-panel-main-content-left.component.converter'
import {
  OPEN_PANEL_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN, OpenPanelMainContentLeftRowConverter
} from './open-panel-main-content-left-row/open-panel-main-content-left-row.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        openPanelMainContentLeftFeature: {
          module: () => import('./open-panel-main-content-left.module').then((m) => m.OpenPanelMainContentLeftModule),
          cmsComponents: ['openpanelmaincontentleft'],
          dependencies: [
            () => import('../open-panel-subcomponent-wrapper/open-panel-subcomponent-wrapper-feature.module').then(m => m.OpenPanelSubcomponentWrapperFeatureModule)
          ]
        },
      }
    }),
    {
      provide: OPEN_PANEL_MAIN_CONTENT_LEFT_CONVERTER_TOKEN,
      useExisting: OpenPanelMainContentLeftConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        openpanelmaincontentleft: OPEN_PANEL_MAIN_CONTENT_LEFT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: OPEN_PANEL_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN,
      useExisting: OpenPanelMainContentLeftRowConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        openpanelmaincontentleftrow: OPEN_PANEL_MAIN_CONTENT_LEFT_ROW_CONVERTER_TOKEN
      },
      multi: true
    },
  ]
})
export class OpenPanelMainContentLeftFeatureModule {}
